import i18n from "@/lib/i18n";
import type {
  EquipmentAssetStatus,
  EquipmentProtocolDirection,
  EquipmentProtocolStatus,
  StaffEquipmentStatus,
  StaffEquipmentType,
} from "@/types/equipment";

export function staffTypeLabel(type: StaffEquipmentType): string {
  if (type === "card") return i18n.t("admin.equipment.labels.card");
  if (type === "key") return i18n.t("admin.equipment.labels.key");
  return i18n.t("admin.equipment.labels.item");
}

export function staffStatusLabel(status: StaffEquipmentStatus): string {
  switch (status) {
    case "pending_handover":
      return i18n.t("admin.equipment.labels.staff.pending_handover");
    case "assigned":
      return i18n.t("admin.equipment.labels.staff.assigned");
    case "pending_return":
      return i18n.t("admin.equipment.labels.staff.pending_return");
    case "returned":
      return i18n.t("admin.equipment.labels.staff.returned");
    default:
      return status;
  }
}

export function assetStatusLabel(status: EquipmentAssetStatus): string {
  switch (status) {
    case "available":
      return i18n.t("admin.equipment.labels.asset.available");
    case "pending_handover":
      return i18n.t("admin.equipment.labels.asset.pending_handover");
    case "assigned":
      return i18n.t("admin.equipment.labels.asset.assigned");
    case "pending_return":
      return i18n.t("admin.equipment.labels.asset.pending_return");
    case "retired":
      return i18n.t("admin.equipment.labels.asset.retired");
    default:
      return status;
  }
}

export function protocolDirectionLabel(direction: EquipmentProtocolDirection): string {
  return direction === "return"
    ? i18n.t("admin.equipment.labels.direction.return")
    : i18n.t("admin.equipment.labels.direction.handover");
}

export function protocolStatusLabel(status: EquipmentProtocolStatus): string {
  switch (status) {
    case "pending":
      return i18n.t("admin.equipment.labels.protocol.pending");
    case "accepted":
      return i18n.t("admin.equipment.labels.protocol.accepted");
    case "rejected":
      return i18n.t("admin.equipment.labels.protocol.rejected");
    case "cancelled":
      return i18n.t("admin.equipment.labels.protocol.cancelled");
    default:
      return status;
  }
}

export function truncateText(value: string | null | undefined, max = 80): string {
  const text = value?.trim() ?? "";
  if (!text) return "—";
  if (text.length <= max) return text;
  return `${text.slice(0, max - 1)}…`;
}

export function protocolItemMeta(
  protocol: { kind: string; asset_id: string | null; staff_equipment_id: string | null; condition_notes: string | null },
  assets: { id: string; name: string; serial_number: string | null }[],
  keys: { id: string; name: string }[],
): { name: string; serialNumber: string | null; conditionNotes: string | null } {
  if (protocol.kind === "asset") {
    const asset = assets.find((item) => item.id === protocol.asset_id);
    return {
      name: asset?.name ?? i18n.t("admin.equipment.labels.tool"),
      serialNumber: asset?.serial_number ?? null,
      conditionNotes: protocol.condition_notes,
    };
  }
  const item = keys.find((row) => row.id === protocol.staff_equipment_id);
  return {
    name: item?.name ?? i18n.t("admin.equipment.labels.item"),
    serialNumber: null,
    conditionNotes: protocol.condition_notes,
  };
}
